import { useSelector } from 'react-redux';
import { getSettingsModifyWhileLive } from '../stores/algo-edit-config/getters';

function useModifyWhileLive() {
  const modifyWhileLive = useSelector(getSettingsModifyWhileLive);

  return modifyWhileLive;
}

export default useModifyWhileLive;
